import { Button, Stack, Theme, Typography } from '@mui/material';
import { Trans } from 'react-i18next';
import { useLocation } from 'react-router';

import { ProgressDots } from '@/components/DataDisplay/Indicator/ProgressDots';
import Logo from '@/components/Icon/Logo';
import { Screen } from '@/components/Layout/Screen';

import { useAppSelector } from '@/hooks/redux';
import { useAuthentication } from '@/hooks/useAuthentication';
import { useTranslate } from '@/hooks/useTranslate';

import { selectConfigsState } from '@/redux/configs/selectors';
import { selectUserHolderJointAdult } from '@/redux/user-data/selectors';

import { getDataTestId } from '@/utils/browser';
import { PROGRESS_STEPS } from '@/utils/progressSteps';

const AddAdultDetailScreenComponent: React.FC = () => {
  const { t, language } = useTranslate();
  const { logo } = useAppSelector(selectConfigsState);
  const { state } = useLocation();
  const holderJointAdult = useAppSelector(selectUserHolderJointAdult);
  const { onBackToSignIn } = useAuthentication();

  return (
    <Screen
      header={{
        centerSlot: (
          <ProgressDots
            value={PROGRESS_STEPS.thirdPartyComplianceCheckStep.value}
            total={PROGRESS_STEPS.thirdPartyComplianceCheckStep.total}
          />
        ),
      }}
      bgColor={(theme: Theme) => theme.palette.background.paper}
    >
      <Stack
        direction="column"
        flex={1}
        justifyContent="center"
        alignItems="center"
      >
        <Logo src={logo} alt="Logo" />
        <Stack direction="column" gap={3}>
          <Typography variant="h3" textAlign="center" mb={1}>
            {t('common.pageTitle.thankYou')}
          </Typography>
          <Typography variant="body2" textAlign="center">
            <Trans
              i18nKey="page.addAdultDetailResult.content"
              language={language}
              as="div"
              values={{
                adultEmail:
                  state?.adultDetail?.email ?? holderJointAdult?.email ?? '',
              }}
              components={{
                strong: <strong />,
              }}
            />
          </Typography>
        </Stack>
      </Stack>
      <Button
        onClick={onBackToSignIn}
        {...getDataTestId('back-to-login-button')}
        variant="text"
      >
        {t('layout.page.button.backToLogin')}
      </Button>
    </Screen>
  );
};

export default function AddAdultDetailResultScreen() {
  return <AddAdultDetailScreenComponent />;
}
